import { handleActions } from 'redux-actions';
import { initState } from '../../../redux/models';
import * as actionType from './actionType';

export default handleActions(
  {
    //更新信息
    [actionType.EXPENSEQUERY_UPDATE]: (state, { data }) => {
      const newState = { ...state, ...data };
      return newState;
    },
    [actionType.EXPENSEQUERY_FILE]: state => {
      const newState = { ...state, modalTuttonLoading: false, tableLoading: false };
      return newState;
    },
  },
  initState,
);
